import { configureStore } from '@reduxjs/toolkit';
import userReducer, { initialUserState } from './user.slice';
import adminReducer, { initialAdminState } from './admin.slice';
import { readStoredAdmin, readStoredUser } from './session';

/**
 * Lo stato iniziale viene idratato da localStorage (A4) **prima** del primo
 * render: i guard (`RequireUser`, `RequireAdmin`) trovano la sessione già attiva,
 * quindi un ricaricamento della pagina non fa più il logout. Il ripristino dentro
 * `AdminLayout` non poteva funzionare, perché il componente è montato solo dopo
 * che `RequireAdmin` ha verificato `admin.logged`.
 */
export const store = configureStore({
    reducer: {
        user: userReducer,
        admin: adminReducer,
    },
    preloadedState: {
        user: readStoredUser() ?? initialUserState,
        admin: readStoredAdmin() ?? initialAdminState,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
